<div class="body">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 center">
          <img [src]="brand.loginLogo" [alt]="brand.brandName" class="logo-image" [style.width]="brand.loginLogoWidth" [style.margin-bottom]="brand.loginLogoMarginBottom">
        </div>
        <h3 *ngIf="isValidToken">Update Password</h3>
        <div class="col-sm-12 input-container-box" *ngIf="isValidToken">
          <form [formGroup]="form" (ngSubmit)="resetPassword()">
            <div class="form-group input-container">
                <input type="password" formControlName="newPassword" class="form-control input-field" placeholder="New Password">
                <div class="alert error-field" *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors && form.controls.newPassword.errors.required">
                    New Password is required
                </div>
            </div>
            <div class="form-group input-container">
                <input type="password" formControlName="confirmNewPassword" class="form-control input-field" placeholder="Confirm Password">
                <div class="alert error-field" *ngIf="form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.errors && form.controls.confirmNewPassword.errors.required">
                    Confirm Password is required
                </div>
            </div>
            <div class="alert error-field" *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors == null 
            && form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.errors == null 
            && form.hasError('notMatched')">
                Password Not Matched
            </div>
            <div [ngClass]="{'text-danger': checkPasswordValidations(), 'text-light': !checkPasswordValidations(), 'form-group': true}">
                Password must contain Min 1 Uppercase letter, Min 1 Lowercase letter, Min 1 Number, Min 1 Special character, Min 8 Characters.
            </div>
            <div class="form-group input-container btn-container">
              <button [disabled]="loading || !form.valid" class="btn btn-submit">Submit</button>
            </div>
            <div *ngIf="error" class="alert error-field">{{error}}</div>
          </form>
        </div>
        <div class="col-sm-12 center input-container-box" *ngIf="!isValidToken">
          <img src="../../../assets/images/error-cross.png" alt="Error" class="error-image">
          <h3>Link Expired or Invalid</h3>
          <p>Sorry, The link to Update your password is either expired or invalid.</p>
          <p>Please request a new password Update <a [routerLink]="['/forgot-password']">here</a>.</p>
        </div>
      </div>
    </div>
  </div>